import { Toast } from '../../../../components/Common/Toast';
import { getCurrentTimestamp } from '../../../../helper/helper';
import { HTTPStatusEnum } from '../../../../interfaces/log.interface';
import { callAPI } from '../../../../services/api.service';
import { getAdminArtStyles } from '../../ArtStyles/services/Artstyle.service';

export const handleUserSubmitService = async (formikValues: any, userDetails: any) => {
  try {
    let response;
    if (!userDetails) {
      response = await callAPI('admin/user/add', {
        userId: formikValues.email,
        firstName: formikValues.firstName,
        lastName: formikValues.lastName,
        email: formikValues.email,
        password: formikValues.password,
        role: formikValues.role
      });
    } else {

      response = await callAPI('admin/user/update', {
        userId: formikValues.email,
        firstName: formikValues.firstName,
        lastName: formikValues.lastName,
        email: formikValues.email,
        password: formikValues.password ? formikValues.password : null,
        role: formikValues.role || ''
      });
    }

    if (response?.error) {
      Toast(response?.error, true);
      return false;
    } else {
      Toast('User Saved Successfully');
      return true;
    }
  } catch (error) {
    throw error;
  }
};

export const handleArtStyleSubmitService = async (
  formikValues: any,
  artStyleDetails: any,
  resetForm: () => void,
  setLoader: (value: boolean) => void,
  setArtStyles: (artStyles: any) => void,
  setShowForm: (value: boolean) => void
) => {
  const formData = new FormData();
  formData.append('artStyleId', artStyleDetails?.id || '');
  formData.append('name', formikValues.name);
  formData.append('subPrompt', formikValues.subPrompt);
  formData.append('srefImage', formikValues.srefImage as Blob);
  formData.append('use_sref', formikValues.use_sref ? '1' : '0');
  formData.append('main_art_character_description', formikValues.mainArtCharacterDescription || '');
  formData.append('name_in_scene', formikValues.nameInScene || '');

  try {
    setLoader(true);

    // const token = TokenCookieManager.getToken();
    // const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/artstyle/update`, {
      method: 'POST',
      credentials: 'include', // Always include cookies
      body: formData
    });

    setLoader(false);

    if (response.status !== HTTPStatusEnum.OK) {
      const errorData = await response.json();
      Toast(errorData.message || errorData.error, true);
    } else {
      Toast('Art Style Saved Successfully');
      resetForm();
      await getAdminArtStyles(setArtStyles);
      setShowForm(false);
    }
  } catch (error) {
    setLoader(false);
  }
};

export const handleCouponSubmitService = async (
  formikValues: any,
  setLoader: (value: boolean) => void,
  getCoupons: () => void,
  setShowForm: (value: boolean) => void
) => {
  try {
    setLoader(true);

    const response = await callAPI('admin/coupon/save', {
      couponId: formikValues.couponId,
      couponCode: formikValues.couponCode,
      couponType: formikValues.couponType,
      couponAmount: formikValues.couponAmount,
      couponAppliedFor: formikValues.couponAppliedFor,
      couponExpiry: formikValues.couponExpiry,
      couponValidity: formikValues.couponValidity,
      couponValidForMonths: formikValues.couponValidForMonths,
      couponDescription: formikValues.couponDescription
    });

    if (response?.status !== HTTPStatusEnum.OK) {
      Toast(response?.message, true);
    } else {
      Toast('Coupon Saved Successfully');
      getCoupons();
      setShowForm(false);
    }
  } catch {
  } finally {
    setLoader(false);
  }
};

export const handleTopUpCreditsService = async (
  formikValues: any,
  showCreditForm: string,
  book: any,
  setLoader: (value: boolean) => void,
  getAllUsers: () => void,
  getUserBooks: (email: string) => void,
  setShowCreditForm: (value: boolean) => void
) => {
  let title = 'Image';
  if (!book) title = 'Story';

  try {
    setLoader(true);
    const response = await callAPI('admin/user/topup-credits', {
      email: showCreditForm,
      bookId: book ? book?.id : null,
      credits: formikValues.newCredits
    });

    if (response?.error) {
      Toast(response?.error, true);
    } else {
      Toast(`${title} Credits Updated Successfully`);
      getAllUsers();
      getUserBooks(showCreditForm);
      setShowCreditForm(false);
    }
  } catch {
    Toast(`Error ${title} Credits Topup`, true);
  } finally {
    setLoader(false);
  }
};

export const savePlan = async (
  planDetails: any,
  formikValues: any,
  getPlans: Function,
  setPlans: Function,
  setLoader: Function,
  setShowForm: Function,
  pricing?: any[]
) => {
  let response;

  try {
    setLoader(true);

    const planData: any = {
      name: formikValues.name,
      cost: formikValues?.cost,
      chargeCycle: formikValues?.chargeCycle,
      storyCreationLimit: formikValues.storyCreationLimit,
      imageCredits: formikValues.imageCredits,
      additionalImageCredits: formikValues.additionalImageCredits,
      additionalImageCreditsCost: formikValues.additionalImageCreditsCost,
      maxBookPage: formikValues.maxBookPage,
      additionalStoryCreationLimit: formikValues?.additionalStoryCreationLimit,
      additionalStoryCreationCost: formikValues?.additionalStoryCreationCost,
      modeCharacterGeneration: formikValues?.modeCharacterGeneration,
      modeIllustrationGeneration: formikValues?.modeIllustrationGeneration,
      maintenanceMode: formikValues?.maintenanceMode,
      showOnSubscription: formikValues?.showOnSubscription,
      trialDays: formikValues?.trialDays,
      freePhysicalBookStatus: formikValues?.freePhysicalBookStatus,
      freePhysicalBookQuantity: formikValues?.freePhysicalBookQuantity,
      mics: formikValues?.mics,
      // Add multi-currency pricing
      pricing: pricing || []
    };

    if (planDetails) {
      planData.planId = formikValues.planId;
    }

    response = await callAPI('admin/plan/save', planData);

    setLoader(false);

    if (response?.status !== 200) {
      Toast(response?.message || response?.error, true);
    } else {
      Toast('Plan Saved Successfully');
      getPlans(setPlans); // Refresh the plans list after saving
      setShowForm(false); // Close the form
    }
  } catch (error) {
    setLoader(false);
    Toast('Plan Failed To Save', true);
  }
};

export const saveAdminSettingsService = async (
  formikValues: any,
  setLoader: (value: boolean) => void,
  setShowForm: (value: boolean) => void,
  getAllSettings: () => void
) => {
  try {
    setLoader(true);

    const response = await callAPI('admin/settings/update-admin-settings/', {
      settingKey: formikValues.settingKey,
      settingTitle: formikValues.settingTitle,
      settingValue: formikValues.settingValue
    });

    if (response?.error) {
      Toast(response?.error, true);
    } else {
      Toast('Setting Saved Successfully');
      getAllSettings(); // Refresh settings
      setShowForm(false);
    }

    setLoader(false);
    formikValues.resetForm();
  } catch {
    setLoader(false);
  }
};

export const resetFlyerGenerationService = async (
  email: string,
  type: 'pre' | 'post' | 'all'
): Promise<boolean> => {
  try {
    const response = await callAPI('admin/user/reset-flyer-generation', { email, type });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Flyer generation reset');
      return true;
    }
    Toast(response?.message || 'Failed to reset flyer generation', true);
    return false;
  } catch {
    Toast('Failed to reset flyer generation', true);
    return false;
  }
};

// Service function to handle updating the user profile
export const updateUserProfileService = async (
  data: { email: string; firstName: string; lastName: string; status: string; settings: any; teacherOnboardingStatus?: string },
  setLoader: (value: boolean) => void,
  onClose: () => void
) => {
  try {
    setLoader(true);
    const response = await callAPI('admin/user/customer-profile-update', data);

    if (response?.status === HTTPStatusEnum.OK) {
      Toast('User Updated Successfully');
      onClose();
    } else {
      Toast(response?.message || 'Failed To Update Profile', true);
    }
  } catch (error) {
  } finally {
    setLoader(false);
  }
};


export const addNewCost = async (
  planDetails: any,
  cost: string,
  costHistory: any[],
  setCostHistory: Function,
  setNewCostLoader: Function,
  setPlanDetails: Function,
  getUpdatedPlanDetails: Function
) => {
  try {
    setNewCostLoader(true);

    // Call the API to add the new cost
    const response = await callAPI('admin/plan/add-plan-new-cost', {
      planId: planDetails?.id,
      newCost: cost
    });

    if (response?.status === HTTPStatusEnum.OK) {
      // Update the cost history and plan details
      setCostHistory([...costHistory, { cost, timestamp: getCurrentTimestamp() }]);
      await getUpdatedPlanDetails(planDetails, setPlanDetails, setCostHistory);
      Toast('New Cost Added Successfully');
    } else {
      Toast(response?.message, true);
    }
    setNewCostLoader(false);
  } catch (error) {
    setNewCostLoader(false);
    Toast('Something went wrong! Try again!', true);
  }
};

// Function to fetch updated plan details
export const getUpdatedPlanDetails = async (planDetails: any, setPlanDetails: any, setCostHistory: any) => {
  try {
    const response = await callAPI(`plans/getPlans`);
    if (response && response.plans) {
      const selectedPlan = response.plans.find((item: { id: string }) => item.id === planDetails?.id);
      if (selectedPlan) {
        setPlanDetails(selectedPlan);
        setCostHistory(selectedPlan?.costHistory);
      }
    }
  } catch (error) {
  }
};